export default __webpack_public_path__ + "static/media/fundoLoginBg2.0a5e1136.jpg";